import type {ICategory} from '@netx/core-category-next/schema';
import {
	permissionsAllow,
	type IPermissionsAllowParams,
} from '../enablers/permissionsAllow';

export {PermissionMatrixName} from '@netx/core-permissions/utils/allows';
export {PermissionName} from '../constants';

interface CategoryPermissionCheckerParams extends Omit<
	IPermissionsAllowParams,
	'permissions' | 'permissionMatrix'
> {
	category: Pick<ICategory, 'categoryid' | 'permissions' | 'permissionMatrix'>;
}

export const categoryPermissionChecker = ({
	category,
	...rest
}: CategoryPermissionCheckerParams) => {
	return permissionsAllow({
		...rest,
		permissionMatrix: category.permissionMatrix,
		permissions: category.permissions,
	});
};
